import ProductCard from './ProductCard';
import FreeShippingCard from './FreeShippingCard';
import ServiceCard from './ServiceCard';
import MultipleProductCard from './MultipleProductCard';

export default ({ offer }) => {
  switch (offer.type) {
    case 'ProductOffer':
      return <ProductCard offer={offer} />;
    case 'ServiceOffer':
      return <ServiceCard offer={offer} />;
    case 'FreeShippingOffer':
      return <FreeShippingCard offer={offer} />;
    case 'MultipleProductOffer':
      return <MultipleProductCard offer={offer} />;
    default:
      throw Error('unknown offer type');
  }
};
